import { post } from './index';

import { IProxyRequest, IProxyResult } from 'models/payloads/proxy';

export const proxyRequest = (payload: IProxyRequest) => post<IProxyRequest, IProxyResult>('/proxy', payload, true);
